"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _isNumber = _interopRequireDefault(require("lodash/isNumber"));
var _isString = _interopRequireDefault(require("lodash/isString"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _chevronLeft = _interopRequireDefault(require("@spothero/icons/chevron-left"));
var _x = _interopRequireDefault(require("@spothero/icons/x"));
var _dom = _interopRequireDefault(require("@spothero/utils/dom"));
var _Button = _interopRequireDefault(require("../Button/Button"));
var _Portal = _interopRequireDefault(require("../../../Portal/Portal"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class Modal extends _react.PureComponent {
  static defaultProps = {
    renderInBody: true,
    useShim: true,
    showClose: true,
    width: 'normal',
    activeContentIndex: 0,
    closeOnShimClick: true,
    animateOnShow: true
  };
  constructor(props) {
    super(props);
    const {
      width,
      title,
      onBeforeFirstRender
    } = this.props;
    this._isDynamicWidth = (0, _isNumber.default)(width) || width.indexOf('%') > 0;
    this._isAnimating = false;
    this._isTitleString = title ? (0, _isString.default)(title) : false;
    this._childHistory = [];
    if (onBeforeFirstRender) {
      onBeforeFirstRender();
    }
  }
  componentDidMount() {
    const {
      width
    } = this.props;
    setTimeout(() => {
      // if ModalContent throws an error then the container will not be defined
      if (!this._container) {
        return;
      }
      if (this._isDynamicWidth) {
        const newWidth = (0, _isNumber.default)(width) ? `${width}px` // numerical width, set accordingly
        : width; // percentage width, retain and set

        _dom.default.addClass(this._container, 'Modal-container-custom');
        this._container.style.width = newWidth;
      }
      this._show();
    }, 0);
  }
  componentWillUnmount() {
    _dom.default.removeClass('html', 'Modal-open');
  }
  _onCloseClick = evt => {
    if (this._isAnimating) {
      return;
    }
    const {
      onCloseClick
    } = this.props;
    this.hide();
    if (onCloseClick) {
      onCloseClick();
    }
  };
  _onShimClick = evt => {
    const {
      useShim,
      closeOnShimClick
    } = this.props;
    if (useShim && closeOnShimClick && _dom.default.hasClass(evt.target, 'Modal-wrapper')) {
      this._onCloseClick();
    }
  };
  _onBackClick = evt => {
    this.props.onRemoveIndex();
  };
  _show() {
    const {
      useShim,
      renderInBody,
      onShown,
      animateOnShow
    } = this.props;
    const node = useShim ? this._modal : this._container;
    const showClass = useShim ? 'Modal-showing' : 'Modal-container-showing';
    _dom.default.addClass(node, showClass);
    if (renderInBody) {
      _dom.default.addClass('html', 'Modal-open');
    }
    if (!useShim) {
      _dom.default.addClass(this._modal, 'Modal-no-shim');
    }
    if (animateOnShow) {
      this._isAnimating = true;
      window.transitionEnd?.(node).bind(() => {
        window.transitionEnd(node).unbind();
        if (onShown) {
          onShown();
        }
        this._isAnimating = false;
      });
    } else {
      if (onShown) {
        onShown();
      }
    }
  }
  _renderModal() {
    const {
      className,
      renderInBody,
      useShim,
      title,
      showClose,
      children,
      width,
      animateOnShow,
      activeContentIndex,
      fullScreenOnMobile,
      'data-testid': dataTestId
    } = this.props;
    const classes = (0, _classnames.default)('Modal', {
      'Modal-inline': !renderInBody
    }, {
      'Modal-animated': animateOnShow
    }, {
      'Modal-showing': useShim && !animateOnShow
    }, className);
    const containerClasses = (0, _classnames.default)('Modal-container', {
      [`Modal-container-${width}`]: !this._isDynamicWidth
    }, {
      'Modal-container-animated': animateOnShow
    }, {
      'Modal-container-showing': !useShim && !animateOnShow
    });
    const wrapperClasses = (0, _classnames.default)('Modal-wrapper', {
      'Modal-wrapper-full': fullScreenOnMobile
    });
    return /*#__PURE__*/_react.default.createElement("div", {
      ref: node => {
        this._modal = node;
      },
      className: classes,
      "data-testid": dataTestId
    }, useShim && /*#__PURE__*/_react.default.createElement("div", {
      className: "Modal-shim"
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: wrapperClasses,
      onClick: this._onShimClick
    }, /*#__PURE__*/_react.default.createElement("div", {
      ref: node => {
        this._container = node;
      },
      className: containerClasses
    }, title && /*#__PURE__*/_react.default.createElement("div", {
      className: "Modal-title"
    }, this._isTitleString ? /*#__PURE__*/_react.default.createElement("h1", null, title) : title), /*#__PURE__*/_react.default.createElement("div", {
      className: "Modal-ctas"
    }, showClose && /*#__PURE__*/_react.default.createElement(_Button.default, {
      className: "Modal-close",
      "aria-label": "Close Modal",
      onClick: this._onCloseClick
    }, /*#__PURE__*/_react.default.createElement(_x.default, null)), activeContentIndex > 0 && /*#__PURE__*/_react.default.createElement(_Button.default, {
      className: "Modal-back",
      "aria-label": "Go Back",
      onClick: this._onBackClick
    }, /*#__PURE__*/_react.default.createElement(_chevronLeft.default, null))), children)));
  }

  /**
   * Hides the Modal programmatically.
   *
   * @public
   * @param {*} args - The arguments to pass to the onHidden callback in cases where you may need access to something not available in Modal itself.
   * @returns {void}
   */
  hide(...args) {
    this._isAnimating = true;
    const {
      useShim,
      renderInBody,
      onHidden,
      animateOnShow
    } = this.props;
    const node = useShim ? this._modal : this._container;
    const showClass = useShim ? 'Modal-showing' : 'Modal-container-showing';
    if (!animateOnShow) {
      _dom.default.addClass(node, showClass.replace('showing', 'animated'));
    }
    if (!useShim) {
      _dom.default.removeClass(this._modal, 'Modal-no-shim');
    }
    _dom.default.removeClass(node, showClass);
    if (renderInBody) {
      _dom.default.removeClass('html', 'Modal-open');
    }
    window.transitionEnd?.(node).bind(() => {
      window.transitionEnd(node).unbind();
      this._isAnimating = false;
      if (!animateOnShow) {
        _dom.default.removeClass(node, `${showClass}-animated`);
      }
      if (onHidden) {
        onHidden(...args);
      }
    });
  }
  render() {
    const {
      renderInBody,
      store
    } = this.props;
    if (renderInBody) {
      return /*#__PURE__*/_react.default.createElement(_Portal.default, {
        store: store
      }, this._renderModal());
    } else {
      return this._renderModal();
    }
  }
}
exports.default = Modal;